/**
 * @file Writes a decimal amount as signed compact currency: `"+$2.90M"` when
 * it rounds above zero, `"−$232K"` with the U+2212 minus when it rounds below,
 * and `"$0"` otherwise. Consumers: ahead-of-plan figures on the Overview
 * tiles and tables. It never writes a hyphen-minus, and throws on a string
 * that is not a decimal, as `analyticsCompactCurrencyText` does.
 */
import { analyticsCompactCurrencyText } from './analyticsCompactCurrencyText';

const MINUS = '−';

export const analyticsSignedCompactCurrencyText = (decimal: string): string => {
  const text = analyticsCompactCurrencyText(decimal);
  if (text.startsWith('-')) return `${MINUS}${text.slice(1)}`;
  return text === '$0' ? text : `+${text}`;
};
